import { useMemo } from 'react';
import { EnvironmentType, SubstrateType } from '../../resources/plots';
export const usePlotMetaOptions = (t) => {
    return useMemo(() => {
        const environmentOptions = [
            { value: EnvironmentType.greenHouse, label: t('environment_types.green_house') },
            { value: EnvironmentType.openField, label: t('environment_types.open_field') }
        ];
        const substrateOptions = [
            { value: SubstrateType.mineral, label: t('substrate_types.mineral') },
            { value: SubstrateType.organic, label: t('substrate_types.organic') },
            { value: SubstrateType.peatMix, label: t('substrate_types.peat_mix') },
            { value: SubstrateType.coir, label: t('substrate_types.coir') },
            { value: SubstrateType.mineralWood, label: t('substrate_types.mineral_wood') }
        ];
        const substrateLabelPerId = {
            [SubstrateType.mineral]: t('substrate_types.mineral'),
            [SubstrateType.organic]: t('substrate_types.organic'),
            [SubstrateType.peatMix]: t('substrate_types.peat_mix'),
            [SubstrateType.coir]: t('substrate_types.coir'),
            [SubstrateType.mineralWood]: t('substrate_types.mineral_wood')
        };
        return { environmentOptions, substrateOptions, substrateLabelPerId };
    }, [t]);
};
